import { useQuery } from 'react-query';
import { httpService } from '../../services/http.service';
import { BASE_URL, USER } from '../../constants/endpoints';
import { HOOKS_SETTINGS } from '../constants';

const { METHOD: { POST } } = HOOKS_SETTINGS;
const {
  CONTROLLERS: {
    GET_URL_TO_CHANGE_PIN: {
      VERSION, BASE, END,
    },
  },
} = USER;
export const useGetLinkToSetPinQuery = ({
  customerId, onSuccess, cardId,
}: { customerId: string, onSuccess?: () => void, cardId:string, }) => useQuery(
  'GetLinkToSetPin',
  async () => {
    if (!customerId || !cardId) {
      return null;
    }
    const { data } = await httpService({
      url: `${BASE_URL}/api/${VERSION}/user/${customerId}/${BASE}/${cardId}/${END}`,
      method: POST,
    });
    return data;
  },
  {
    enabled: false,
    cacheTime: 0,
    onSuccess: () => {
      if (onSuccess) onSuccess();
    },
  },
);
